import axios from "axios";
import authHeader from '../../../authheader'

const PLSNOTIFICATIONPREFERENCEURL = process.env.REACT_APP_APIURL + "/api/NotificationPreferences";


const getPrivacyData = (entityId) => {
    return axios.get(`${PLSNOTIFICATIONPREFERENCEURL}/journalandprivacy`, { headers: authHeader(), params: { entityId } });
}
const postPrivacyData = (data) => {
    return axios.post(`${PLSNOTIFICATIONPREFERENCEURL}/journalandprivacy`, data, { headers: authHeader() });
}
export default {
    getPrivacyData,
    postPrivacyData
}